import { Heart, Search, Sparkles, BarChart3 } from "lucide-react";

const steps = [
  { icon: Heart, title: "Detectar", text: "El empleado expresa cómo se siente, en menos de 30 segundos." },
  { icon: Search, title: "Entender", text: "La app ayuda a identificar qué puede estar detrás de esa emoción." },
  { icon: Sparkles, title: "Actuar", text: "Herramientas prácticas y personalizadas para recuperar el equilibrio." },
  { icon: BarChart3, title: "Aprender", text: "Las empresas obtienen tendencias emocionales anónimas para mejorar el bienestar del equipo." },
];

export function HowItWorks() {
  return (
    <section id="como-funciona" className="relative py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-3xl text-center">
          <span className="inline-flex items-center gap-2 rounded-full border border-border bg-card px-3 py-1 text-xs font-medium text-muted-foreground">
            Cómo funciona
          </span>
          <h2 className="mt-5 text-3xl font-semibold tracking-tight text-foreground sm:text-4xl lg:text-5xl">
            Intervención emocional <span className="text-gradient-brand">en tiempo real</span>
          </h2>
          <p className="mt-5 text-lg text-muted-foreground">
            Hummany acompaña a las personas justo en el momento en que necesitan recuperar claridad, calma o control.
          </p>
        </div>

        <div className="mt-16 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <div key={s.title} className="group relative rounded-3xl border border-border bg-card p-7 shadow-soft transition hover:-translate-y-1 hover:shadow-elevated">
              <div className="flex items-center justify-between">
                <span className="flex h-12 w-12 items-center justify-center rounded-2xl gradient-soft">
                  <s.icon className="h-5 w-5 text-primary" strokeWidth={2} />
                </span>
                <span className="text-sm font-medium text-muted-foreground">0{i + 1}</span>
              </div>
              <h3 className="mt-6 text-lg font-semibold text-foreground">{s.title}</h3>
              <p className="mt-2 text-sm text-muted-foreground">{s.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
